import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import { StudentForm } from "../../../../components/Admin/TeacherCmp";
import { StudentList } from "../../../../components/Admin/StudentCmp";
import { useTranslation } from "react-i18next";
import "./Page_Institution_Student.scss";

export function Page_Institution_Student() {
  const { user, accessToken } = useAuth();
  const { t } = useTranslation("institutions");

  // Estado para el modal
  const [showModalAlumno, setShowModalAlumno] = useState(false);
  // Estado para recargar la lista de estudiantes
  const [reload, setReload] = useState(false);

  // Función para alternar el modal
  const onOpenCloseModalAlumno = () =>
    setShowModalAlumno((prevState) => !prevState);

  // Función para forzar la recarga de estudiantes
  const onReload = () => setReload((prevState) => !prevState);

  return (
    <div className="institution-profile-page">
      {/* Botón para abrir el modal */}
      <div className="buttons-container">
        <Button className="button-alumno" onClick={onOpenCloseModalAlumno}>
          {t("pages.newStudentButton")}
        </Button>
      </div>

      {/* Listado de Alumnos */}
      <div>
        <h1>{t("pages.studentListTitle")}</h1>
        <StudentList
          user={user}
          accessToken={accessToken}
          close={onOpenCloseModalAlumno}
          reload={reload}
          onReload={onReload}
        />
      </div>

      {/* Modal para crear o editar un Alumno */}
      <BasicModal
        show={showModalAlumno}
        close={onOpenCloseModalAlumno}
        title={t("pages.createStudentTitle")}
      >
        <StudentForm
          user={user}
          close={onOpenCloseModalAlumno} // Cierra el modal después de crear/actualizar
          onReload={onReload} // Recarga la lista de estudiantes
        />
      </BasicModal>
    </div>
  );
}
